"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Circle_1 = __importDefault(require("./Circle"));

var CarouselItem_1 = require("./CarouselItem");

var Video =
/** @class */
function (_super) {
  __extends(Video, _super);

  function Video(props) {
    var _this = _super.call(this, props) || this;

    _this.startPlay = function () {
      var onStateChange = _this.props.onStateChange;

      _this.video.play();

      _this.setState({
        isPlaying: true
      });

      if (onStateChange) {
        onStateChange(true);
      }
    };

    _this.showPlay = function () {
      var onStateChange = _this.props.onStateChange;

      _this.setState({
        isPlaying: false
      });

      if (onStateChange) {
        onStateChange(false);
      }
    };

    _this.state = {
      isPlaying: false
    };
    return _this;
  }

  Video.prototype.render = function () {
    var _this = this;

    return React.createElement(VideoWrapper, null, !this.state.isPlaying && !this.props.controls && this.props.playButton && React.createElement(PlayButton, {
      onClick: this.startPlay
    }, React.createElement(Circle_1["default"], {
      color: "rgba(0, 0, 0, 0.2)"
    }, "Play")), React.createElement(exports.VideoStyled, {
      muted: this.props.muted,
      loop: this.props.loop,
      playsInline: this.props.playsInline,
      autoPlay: this.props.autoPlay,
      controls: this.props.controls,
      preload: this.props.poster ? "none" : "auto",
      poster: this.props.poster ? "" + this.props.poster : undefined,
      ref: function ref(x) {
        return _this.video = x;
      },
      onEnded: this.showPlay,
      onPause: this.showPlay
    }, typeof this.props.src === "string" ? React.createElement("source", {
      src: this.props.src
    }) : Object.keys(this.props.src).map(function (key) {
      return React.createElement("source", {
        key: key,
        src: String(_this.props.src[key]),
        type: "video/" + key
      });
    }), "Your broswer does not support the video tag"));
  };

  Video.defaultProps = {
    muted: false,
    controls: false,
    loop: false,
    playsInline: false,
    playButton: true,
    autoPlay: false
  };
  return Video;
}(React.Component);

exports["default"] = Video;
var VideoWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n"], ["\n  display: inline-block;\n  position: relative;\n"])));
exports.VideoStyled = styled_components_1["default"].video(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 100%;\n  height: auto;\n"], ["\n  max-width: 100%;\n  height: auto;\n"])));
var PlayButton = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  z-index: 2;\n  // Don't show the play button when placed inside a CarouselItem\n  ", " & {\n    display: none;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  z-index: 2;\n  // Don't show the play button when placed inside a CarouselItem\n  ", " & {\n    display: none;\n  }\n"])), CarouselItem_1.CarouselItemWrapper);
var templateObject_1, templateObject_2, templateObject_3;